export default "__VITE_PUBLIC_ASSET__fa2bcd1f__"